(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-columns"] && !Shopify.designMode) return;
  try {
    
  const videos = document.querySelectorAll('.column__item__image.column__item__video-link');
  videos.forEach((videoContainer) => {
    const button = videoContainer.querySelector('button');
    button.addEventListener('click', () => {
      videoContainer.querySelector('[data-bgset]').style.display = 'none';
      videoContainer.querySelector('video').style.display = 'block';
      videoContainer.querySelector('video').play();
      videoContainer.setAttribute('is-playing', true);
      button.style.display = 'none';
    });

    videoContainer.querySelector('video').addEventListener('pause', () => {
      if(videoContainer.getAttribute('is-playing') == 'false') return; 
      videoContainer.querySelector('[data-bgset]').style.display = 'block';
      videoContainer.querySelector('video').style.display = 'none';
      videoContainer.setAttribute('is-playing', false);
      button.style.display = 'block';
    });
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-image-with-text"] && !Shopify.designMode) return;
  try {
    
  const videos = document.querySelectorAll('.image-with-text__image.has-video');
  videos.forEach((videoContainer) => {
    const button = videoContainer.querySelector('button');
    button.addEventListener('click', () => {
      videoContainer.querySelector('[data-bgset]').style.display = 'none';
      videoContainer.querySelector('video').style.display = 'block';
      videoContainer.querySelector('video').play();
      videoContainer.setAttribute('is-playing', true);
      button.style.display = 'none';
    });

    videoContainer.querySelector('video').addEventListener('pause', () => {
      if(videoContainer.getAttribute('is-playing') == 'false') return; 
      videoContainer.querySelector('[data-bgset]').style.display = 'block';
      videoContainer.querySelector('video').style.display = 'none';
      videoContainer.setAttribute('is-playing', false);
      button.style.display = 'block';
    });
  }); 

  } catch(e) { console.error(e); }
})();
})();
